import { Box, Grid, Tab, Tabs, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import location from "../../assets/icon/location.png";
import Footer from "../../common/Footer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import course_img from "../../assets/furnit.jpg";
import { useNavigate } from "react-router";
// import { getAllCourses } from "./coursesApi";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../common/debounce";
import SearchIcon from "@mui/icons-material/Search";
import { setchangeRoll } from "../../app/store/reducer";
import { getAllCourses } from "../institute/coursesApi";
import { ArrowBackIcon } from "../../common/icon";
// import { ArrowBackIcon } from './icon';
import FavoriteIcon from "@mui/icons-material/Favorite";
import { routePath } from "../../constants/routePath";
export default function FavouritePage() {
  const navigate = useNavigate();
  const [allCourse, setAllCourse] = useState();
  const searchValue = useSelector((state) => state.reducer.searchValue);
  const [searchhere, setSearchHere] = useState("");
  const debouncedSearchHere = useDebounce(searchhere, 500);
  const debouncedSearchValue = useDebounce(searchValue, 500);
  const dispatch = useDispatch();

  const getCourses = async () => {
    const payload = {
      search1: [
        {
          value: debouncedSearchValue || debouncedSearchHere,
        },
      ],
      search2: [
        {
          value: "",
        },
      ],
      search3: [
        {
          value: "",
        },
      ],
    };

    // console.log("bbbb", billerId);

    getAllCourses(payload, (data) => {
      // console.log("Courses- ", data.data.data.list);
      setAllCourse(data.data.data.list);
    });
  };
  useEffect(() => {
    getCourses();
  }, [debouncedSearchValue, debouncedSearchHere]);

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  return (
    <>
      <Box
        sx={{
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
          p: { xs: 2, sm: 3, md: 5 },
          px: { xs: 2, sm: 6, md: 12 },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              // justifyContent: "space-between",
              alignItems: "center",
              // mb: { xs: 2, sm: 3, md: 4 },
              gap: 1,
            }}
          >
            <ArrowBackIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/")}
            />
          </Box>

          <TextField
            placeholder={`Search ...`}
            fullWidth
            InputProps={{
              endAdornment: (
                <SearchIcon
                  sx={{ cursor: "pointer" }}
                  // onClick={handleSearchClick}
                />
              ),
            }}
            sx={{
              backgroundColor: "#fff",
              "& .MuiInputBase-input": {
                padding: "7.5px 10px !important",
                fontFamily: "Kanit",
              },
              display: { sm: "none", xs: "block" },

              "& .MuiInputBase-input::placeholder": {
                color: "#585858",
                opacity: 1,
              },
            }}
            // onClick={handleSearchClick}
            value={searchhere}
            // onChange={(e) =>
            //   dispatch(setSearchValue(e.target.value))
            // }

            onChange={(e) => setSearchHere(e.target.value)}
            // onClick={(e) => handleSearchClickOrType(e)}
          />
        </Box>

        <Grid container spacing={{ xs: 2, sm: 2 }}>
          {allCourse?.map((course) => {
            return (
              <Grid item xs={12} sm={6} md={3} lg={2} key={course.id}>
                <Box
                  onClick={() => {
                    navigate(`/furnatureDetials/${course.id}`);
                    sessionStorage.setItem("mode", "customer");
                    dispatch(setchangeRoll("customer"));
                  }}
                  sx={{
                    p: 1,
                    borderRadius: 2,
                    backgroundColor: "#EAEAFF",
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <Box
                    component="img"
                    src={course_img}
                    sx={{
                      // maxHeight: 300,
                      height: 250,
                      width: "100%",
                      objectFit: "center",
                      mb: 2,
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: { xs: "10px", sm: "13px", md: "15px" },
                          fontWeight: 600,
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          flex: 1,
                        }}
                      >
                        {course.courseName || "-"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "14px", md: "16px" },
                          fontWeight: 700,
                          // mt: 0.5,
                          color: "#00000",
                        }}
                      >
                        ₹ 20,000
                      </Typography>
                    </Box>

                    <Box>
                      <FavoriteIcon
                        sx={{
                          fontSize: 30,
                          color: "red",
                          mb: 0,
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Course ID */}

                  <Box
                    sx={
                      {
                        // position: "absolute",
                        // bottom: 10,
                        // right: 16,
                        // display: "flex",
                        // alignItems: "center",
                        // gap: 0.5,
                      }
                    }
                  >
                    {/* <CheckCircleIcon sx={{ fontSize: 16, color: "#27A42D" }} /> */}
                    <Typography
                      sx={{
                        fontSize: { xs: "10px", sm: "13px", md: "14px" },

                        fontWeight: 600,
                        color: "#575757",
                      }}
                    >
                      Posted On {formatDate(course?.createdDate)}
                    </Typography>
                  </Box>

                  {/* Details */}

                  {/* Already Applied */}
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>

      <Box sx={{ pt: 10 }}>
        <Footer />
      </Box>
    </>
  );
}
